import { Heading } from "grommet";
import React from "react";
import logoImage from "../../assets/images/logo.svg";
import { COLOR_WHITE } from "../../constants/colors";

const Logo = ({
  size = 64,
  type = "default",
  background = COLOR_WHITE,
  color = COLOR_WHITE,
  className,
}: {
  type?: "text" | "default" | "plain" | "plain-color";
  size?: number;
  background?: string;
  color?: string;
  className?: string;
}) => {
  if (type === "default") {
    return (
      <img
        className={className}
        src={logoImage}
        alt="Due Logo"
        style={{
          background: background,
          padding: 8,
          borderRadius: 6,
          height: size,
        }}
      />
    );
  } else if (type === "plain") {
    return (
      <img
        className={className}
        src={logoImage}
        alt="Due Logo"
        style={{ height: size }}
      />
    );
  } else if (type === "plain-color") {
    return (
      <svg
        className={className}
        height={`${size}px`}
        viewBox="0 0 57 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Logo">
          <path
            d="M9,21.915092 C8.48142939,21.9716974 7.96009682,22 7.436,22 L7,22 L7,24 L3,24 L3,22 L0.044,22 L0.044,2.176 L3,2.176 L3,0 L7,0 L7,2.176 L7.212,2.176 C7.8114247,2.176 8.40742361,2.2059419 9,2.26582608 L9,0 L13,0 L13,3.19368902 C13.7152852,3.48731764 14.3806161,3.85275358 14.996,4.29 C16.0600053,5.04600378 16.9186634,6.05866032 17.572,7.328 C18.2253366,8.59733968 18.552,10.165324 18.552,12.032 C18.552,13.7680087 18.2300032,15.2659937 17.586,16.526 C16.9419968,17.7860063 16.0926719,18.8219959 15.038,19.634 C14.4070917,20.1197435 13.7277609,20.5286656 13,20.8607701 L13,24 L9,24 L9,21.9150914 Z M13.568,12.032 C13.568,10.9119944 13.3860018,9.98333702 13.022,9.246 C12.6579982,8.50866298 12.1726697,7.92066886 11.566,7.482 C10.9593303,7.04333114 10.2686705,6.7306676 9.494,6.544 C8.71932946,6.3573324 7.92133744,6.264 7.1,6.264 L4.72,6.264 L4.72,17.856 L6.988,17.856 C7.84667096,17.856 8.6726627,17.758001 9.466,17.562 C10.2593373,17.365999 10.9593303,17.0440022 11.566,16.596 C12.1726697,16.1479978 12.6579982,15.5506704 13.022,14.804 C13.3860018,14.0573296 13.568,13.1333388 13.568,12.032 Z"
            id="Combined-Shape"
            fill="currentColor"
          ></path>
          <path
            d="M38.516,14.524 C38.516,15.7186726 38.3153353,16.8059951 37.914,17.786 C37.5126647,18.7660049 36.9386704,19.6059965 36.192,20.306 C35.4453296,21.0060035 34.5446719,21.551998 33.49,21.944 C32.4353281,22.336002 31.2640064,22.532 29.976,22.532 C28.6693268,22.532 27.4933386,22.336002 26.448,21.944 C25.4026614,21.551998 24.5160036,21.0060035 23.788,20.306 C23.0599964,19.6059965 22.500002,18.7660049 22.108,17.786 C21.715998,16.8059951 21.52,15.7186726 21.52,14.524 L21.52,2.176 L26.28,2.176 L26.28,14.132 C26.28,14.673336 26.3499993,15.1866642 26.49,15.672 C26.6300007,16.1573358 26.8446652,16.5913314 27.134,16.974 C27.4233348,17.3566686 27.8059976,17.6599989 28.282,17.884 C28.7580024,18.1080011 29.3319966,18.22 30.004,18.22 C30.6760034,18.22 31.2499976,18.1080011 31.726,17.884 C32.2020024,17.6599989 32.5893318,17.3566686 32.888,16.974 C33.1866682,16.5913314 33.4013327,16.1573358 33.532,15.672 C33.6626673,15.1866642 33.728,14.673336 33.728,14.132 L33.728,2.176 L38.516,2.176 L38.516,14.524 Z"
            id="Path"
            fill="currentColor"
          ></path>
          <polygon
            id="Path"
            fill="currentColor"
            points="42.38 22 42.38 2.176 55.708 2.176 55.708 6.236 47 6.236 47 9.96 55.232 9.96 55.232 13.796 47 13.796 47 17.912 56.212 17.912 56.212 22"
          ></polygon>
        </g>
      </svg>
    );
  } else {
    return (
      <Heading
        className={className}
        style={{
          fontSize: size,
          fontWeight: "bold",
          color: color,
        }}
      >
        DUE
      </Heading>
    );
  }
};

export default Logo;
